import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';
import { FileService } from './file-service';
import { saveAs } from 'file-saver';

import { Observable, Subject } from "rxjs";

declare var jsPDF: any;

/*
  Generated class for the AlertService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ContratoService {
  urlObtencaoDados: string;
  idPaginaContrato = "955";
  cdModulo = "5";

  private statusModuloPcaSource = new Subject<boolean>();
  statusDoModulo$ = this.statusModuloPcaSource.asObservable();

  limiteDiferencaLimiteLegal: any = 25.00;

  constructor(private utilService: UtilService,
    private gestaoPcaService: GestaoPcaService,
    private fileService: FileService) {
  }

  public verificaSatusModuloPca(idStatusModulo: number) {
    if (idStatusModulo == 8) {
      this.statusModuloPcaSource.next(true);
    }
    else {
      this.statusModuloPcaSource.next(false);
    }
  }
  public obterIdPaginaContrato() {
    return this.idPaginaContrato;
  }

  public listarAnalisesContrato() {
    this.urlObtencaoDados = "analiseContrato?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public listarPorPCA() {
    this.urlObtencaoDados = "contrato/listarPorPca?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public listarPorPCAPag(pag: any, numero: any) {
    this.urlObtencaoDados = "contrato/listarPorPcaPag?idPca=" + this.gestaoPcaService.getPCA().id + "&pag=" + pag + "&nmContrato=" + numero;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public listarContratosPcaPorNumero(numero: any): Observable<any> {
    this.urlObtencaoDados = "contrato/listarPorPcaPorContrato?idPca=" + this.gestaoPcaService.getPCA().id + "&nmContrato=" + numero;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public importarContratos(idPca: any) {
    this.urlObtencaoDados = "contrato/importarContratos?idPca=" + idPca;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public transferirContratosSACC(idPca: any) {
    this.urlObtencaoDados = "contrato/transferirContratosSACC?idPca=" + idPca;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public atualizarContratosAditivos(idPca: any) {
    this.urlObtencaoDados = "contrato/atualizarContratosAditivos?idPca=" + idPca;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public deletarTemp(idPca: any) {
    this.urlObtencaoDados = "contrato/deletarTemp?idPca=" + idPca;
    return this.utilService.deleteJSON(this.urlObtencaoDados);
  }

  public downloadArquivoContratosAditivos(idPca: any) {
    this.urlObtencaoDados = "contrato/downloadArquivoContratosAditivos?idPca=" + idPca;
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public listarTiposDeProduto() {
    this.urlObtencaoDados = "produto/listarTipos";
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public listarForaDoLimitePorPCA() {
    this.urlObtencaoDados = "analiseContrato/obterForaDoLimiteAnalista?idPca=" + this.gestaoPcaService.getPCA().id + "&isJurisdicionado=0";
    return this.utilService.getJSON(this.urlObtencaoDados);
  }

  public salvarArquivoImportado(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "contrato/carga?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public listarTermosDeReferencia(idProcesso, idModuloPca, cdTipoAnalise) {
    let urlObtencaoDados = "arquivo/listarArquivosVinculados/" + this.gestaoPcaService.getPCA().id + "/" + idProcesso + "/" + idModuloPca + "/" + cdTipoAnalise+ "/" + false;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public enviarTermoDeReferenciaContrato(event, idContrato, cdModulo, cdArquivo) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "arquivo/salvar?id=" + idContrato + "&codigoModulo=" + cdModulo + "&idPca=" + this.gestaoPcaService.getPCA().id + "&codigoArquivo=" + cdArquivo;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public downloadTermoDeReferenciaContrato(idArquivoContrato) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');

    this.utilService.getJSON("arquivo/download/" + idArquivoContrato)
      .subscribe(data => {
        if (data != null) {
          let contentType = "data:" + data.mimeType + ";base64";

          let byteCharacters = atob(data.decodedFile);

          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          let file = new Blob([byteArray], { type: contentType });
          saveAs(file, data.filename);
        } else {
          console.log("Ocorreu um erro ao fazer o download do arquivo. Arquivo não encontrado.");
        }
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public deletarTermoDeReferenciaContrato(idArquivoContrato) {
    let urlObtencaoDados: string = "arquivo/deletar/" + idArquivoContrato;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  // public listarTermosDeReferenciaAditivo(idAditivo) {
  //     let urlObtencaoDados = "arquivoAditivo/listar?idAditivo=" + idAditivo;
  //     return this.utilService.getJSON(urlObtencaoDados);
  // }

  public enviarTermoDeReferenciaAditivo(event, idAditivo, idModuloPca) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      // let envioPeca: string = "arquivo/salvar?id=" + pIdProcesso + "&codigoModulo=" + pcodigoModuloPCA + "&idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise=" + ptipoAnalise + "&tipoEntidadeExercicio=" + pTipoEntidadeExercicio + "&tipoDocumento=" + pTipoDocumento + "&dsOrigemArquivo=" + origemArquivo;
      let envioRolXml: string = "arquivo/salvar?id=" + idAditivo + "&codigoModulo=" + idModuloPca + "&idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  // public downloadTermoDeReferenciaAditivo(idArquivoAditivo) {
  //     var headers = new HttpHeaders();
  //     headers.append('responseType', 'arraybuffer');
  //     this.utilService.getJSON("arquivoAditivo/download/" + idArquivoAditivo)
  //         .subscribe(data => {
  //             let contentType = "data:" + data.mimeType + ";base64";

  //             let byteCharacters = atob(data.decodedFile);

  //             let byteNumbers = new Array(byteCharacters.length);
  //             for (var i = 0; i < byteCharacters.length; i++) {
  //                 byteNumbers[i] = byteCharacters.charCodeAt(i);
  //             }

  //             var byteArray = new Uint8Array(byteNumbers);
  //             let file = new Blob([byteArray], { type: contentType });
  //             saveAs(file, data.filename);
  //         },
  //         error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  // }

  // public deletarTermoDeReferenciaAditivo(idArquivoAditivo) {
  //     let urlObtencaoDados: string = "arquivoAditivo/deletar/" + idArquivoAditivo;
  //     return this.utilService.deleteJSON(urlObtencaoDados);
  // }

  public salvarJustificativa(contrato) {
    let urlObtencaoDados = "analiseContrato/salvarJustificativaForaDoLimite";
    return this.utilService.postJSON(urlObtencaoDados, contrato);
  }

  public salvarProdutosDoAditivo(produto) {
    let urlObtencaoDados = "produto/salvarLista?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(urlObtencaoDados, produto);
  }

  public listarProdutosAditivo(idAditivo) {
    let urlObtencaoDados = "produto/listar?id=" + idAditivo;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public deletarProdutosDoAditivo(idProduto) {
    let urlObtencaoDados = "produto/deletar?idProduto=" + idProduto;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  //Regra 1
  public obterDadosResumoRelatorioInspecao() {
    let urlObtencaoDados = "analiseContrato/obterRelatoriosDeInspecao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarDadosResumoRelatorioInspecao(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/salvarRelatoriosDeInspecao?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  public obterArquivoResumoRelatorioInspecao(idDoc) {
    this.fileService.downloadArquivoResumoRelatorioInspecao(idDoc);
  }

  //Regra 2
  public obterDadosAcrescimosOuSupressoes() {
    let urlObtencaoDados = "analiseContrato/obterForaDoLimiteAnalista?idPca=" + this.gestaoPcaService.getPCA().id + "&isJurisdicionado=1";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarDadosAcrescimosOuSupressoes(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/salvarForaDoLimiteAnalista?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  //Regra 3
  public obterDadosExtensaoAcimaLimite() {
    let urlObtencaoDados = "analiseContrato/obterExtensaoAcimaLimite?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarDadosExtensaoAcimaLimite(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/salvarExtensaoAcimaLimite?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  //Regra 4
  public obterDadosNotasSemContrato() {
    let urlObtencaoDados = "analiseContrato/obterNotasSemContrato?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarDadosNotasSemContrato(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/salvarNotasSemContrato?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  //Regra 5
  public obterDadosValidacaoDataDePublicacao() {
    let urlObtencaoDados = "analiseContrato/obterValidacaoDataDePublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterDadosValidacaoDataDePublicacaoAditivo() {
    let urlObtencaoDados = "analiseContrato/obterValidacaoDataDePublicacaoAditivo?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarDadosValidacaoDataDePublicacaoAditivo(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/salvarAnaliseValidacaoAditivoData?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  public salvarDadosValidacaoDataDePublicacao(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/salvarAnaliseValidacaoData?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  //Regra 6
  public obterDadosAnaliseEmpenhoAnteriorAssinatura() {
    let urlObtencaoDados = "analiseContrato/obterAnaliseEmpenhoAnteriorAssinatura?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  //Regra 7
  public obterDadosAnaliseEmpenhoAnteriorPublicacao() {
    let urlObtencaoDados = "analiseContrato/obterAnaliseEmpenhoAnteriorPublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  //Regra 8
  public obterDadosAnaliseEmpenhoPosterior() {
    let urlObtencaoDados = "analiseContrato/obterAnaliseEmpenhoPosterior?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  //Regra 6,7,8 - Salvar
  public salvarDadosAnaliseNotaEmpenho(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/salvarAnaliseNotaEmpenho?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  //submeter de todas as regras
  public submeterAnalise(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/encerrarAnalise?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  public finalizarForaDoLimiteAnalista(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/finalizarForaDoLimiteAnalista?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  public finalizarExtensaoAcimaLimite(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/finalizarExtensaoAcimaLimite?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  public finalizarNotasSemContrato(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/finalizarNotasSemContrato?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  public finalizarAnaliseValidacaoData(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/finalizarAnaliseValidacaoData?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }

  public finalizarAnaliseNotaEmpenho(dados, cdAnalise) {
    let urlObtencaoDados = "analiseContrato/finalizarAnaliseNotaEmpenho?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObtencaoDados, dados);
  }


  //pré-visualizar o certificado
  public obterContratosCertificado() {
    let urlObtencaoDados = "analiseContrato/obterPreviewCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  //finalizar módulo - jurisdicionado
  public finalizarModuloContratos() {
    let urlObtencaoDados = "contrato/submeter?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(urlObtencaoDados, "");
  }

  // public jurisdicionadoEhPoderExecutivo() {
  //     let urlObtencaoDados = "jurisdicionado/verificaPoderExecutivo?idJurisdicionado=" + this.gestaoPcaService.usuarioService.getIdJurisdicionado();
  //     return this.utilService.getJSON(urlObtencaoDados);
  // }

  public obterAditivosPorContrato(idContrato) {
    let urlObtencaoDados = "contrato/listarAditivosPorContrato?idContrato=" + idContrato;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterPorNumeroContrato(numContrato) {
    let urlObtencaoDados = "contrato/obterPorNumero?nmContrato=" + numContrato + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterModuloPca() {
    let urlObtencaoDados = "contrato/obterModuloPca?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  calculaLimiteLegalProduto(produto) {

    if (produto.valor == null || produto.valor == undefined || produto.valor == '' || isNaN(produto.valor)) {
      produto.valor = 0;
    }

    if (produto.valorOriginal == null || produto.valorOriginal == undefined || produto.valorOriginal == '' || isNaN(produto.valorOriginal)) {
      produto.valorOriginal = 0;
    }

    let porcentagemAcrescimoSobreContrato;

    if(produto.valorOriginal == 0) {
      porcentagemAcrescimoSobreContrato = produto.valor;
    } else {
      porcentagemAcrescimoSobreContrato = (produto.valor / produto.valorOriginal) * 100;
    }
    
    let diferencaLimiteAcrescimo;

    if (produto.tipo == "Reajuste"){
      diferencaLimiteAcrescimo = porcentagemAcrescimoSobreContrato;
    } else {
      diferencaLimiteAcrescimo = porcentagemAcrescimoSobreContrato - this.limiteDiferencaLimiteLegal;     
      
      if (diferencaLimiteAcrescimo) {
        if (diferencaLimiteAcrescimo <= 0) {
          diferencaLimiteAcrescimo = 0;
        }
      } else {
        diferencaLimiteAcrescimo = 0;
      }
    }
    
    
    return diferencaLimiteAcrescimo;
  }

  formatarPorcentagem(valor) {
    
    let valorString = valor.toFixed(2);

    /*
    if (valorString.indexOf('.') != -1) {
      let tamanhoAntesDaVirgulas = valorString.indexOf('.') + 1;
      let numeroDeCasasDecimais = 4;
      valorString = valorString.substr(0, tamanhoAntesDaVirgulas + numeroDeCasasDecimais);
    }
    */

    return valorString.replace('.', ',') + "%";
  }

  public getArquivoResumoContrato(idPca): Observable<any> {
    return this.utilService.getJSON(`contrato/obterArquivoResumoContratos?idPca=${idPca}`);
  }

  public gerarDocModuloContrato({idPca, idModuloPca, idResumoContratos}): Promise<any> {
    return new Promise( (resolve, reject) => {

      if (idResumoContratos) {
        this.excluirResumoContrato(idResumoContratos)
          .subscribe( () => this.salvarResumoContratos(idPca, idModuloPca, resolve, reject),
                 error => reject('Erro ao excluir o resumo anterior')
          );
      } else {
        this.salvarResumoContratos(idPca, idModuloPca, resolve, reject)
      }
    });
  }

  private salvarResumoContratos(idPca, idModuloPca, resolve, reject) {

    this.gerarTextoResumoContrato(idPca).subscribe(textoContrato => {
      const doc = this.gerarDocV2(textoContrato);
       
      const docBlob = this.converterParaBlob(doc.output('datauristring'));
      const file = new File([docBlob], "resumo-contratos-para-assinatura-modulo-contrato.pdf", { type: 'application/pdf' });
  
      this.salvarResumoContratosBancoERede(file, idPca, idModuloPca)
         .subscribe(result => resolve(result), error => reject(error));
    });
  }

  private excluirResumoContrato(idResumoContratos) {
    let urlObtencaoDados: string = "arquivo/deletar/" + idResumoContratos;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  private salvarResumoContratosBancoERede(file: File, idPca, codigoModuloPca): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('arquivo', file, file.name);
    const dsOrigemArquivo = 'Resumo Contratos para Assinatura - Módulo Contrato';
    const url: string = 
    `arquivo/salvar?id=0&codigoModulo=${codigoModuloPca}&idPca=${idPca}&cdTipoAnalise=0&tipoEntidadeExercicio=0&tipoDocumento=0&dsOrigemArquivo=${dsOrigemArquivo}`;
    return this.utilService.postArquivo(url, formData);
  }

  /*
    https://github.com/MrRio/jsPDF
    http://raw.githack.com/MrRio/jsPDF/master/
   */
  private gerarDocV2(textoResumoContrato) {

    var pageWidth = 8.5,
    lineHeight = 1.2,
    margin = 0.5,
    maxLineWidth = pageWidth - margin * 2,
    fontSize = 12,
    ptsPerInch = 72,
    oneLineHeight = (fontSize * lineHeight) / ptsPerInch;

    let doc = new jsPDF({
      unit: "in",
      lineHeight: lineHeight
    }).setProperties({ title: "Resumo Contratos" });

    // each of which can be displayed within the specified maxLineWidth.
    var textLines = doc
      .setFont("Times", 'nomal')
      .setFontSize(fontSize)
      .splitTextToSize(textoResumoContrato, maxLineWidth);
 
      // doc.text can now add those lines easily; otherwise, it would have run text off the screen!
      doc.text(textLines, margin, margin + 2 * oneLineHeight);

      doc
        .setFont("Times", "normal")
        .setFontSize(14)
        .text(
          "Resumo Contratos",
          margin,
          margin + oneLineHeight
        );

    return doc;
  }

  private gerarTextoResumoContrato(idPca: number): Observable<any> {
    return this.utilService.getJSON(`contrato/obterTextoResumoContratos?idPca=${idPca}`);
  }

  /*
    https://github.com/MrRio/jsPDF
    http://raw.githack.com/MrRio/jsPDF/master/
   */
  private gerarDoc(contratos) {

    let doc = new jsPDF();
    doc.setFont("times"); 
    doc.setFontType("normal");
    doc.text("RESUMO CONTRATOS", 20, 20);


    const texto = `Declaro para os devidos fins que, no Módulo de Contratos, forma apresentados todos os documentos dos ${contratos.length} 
      contratos vigentes no exercício da presente PCA, bem como os detalhamentos de seus respectivos aditivos.`;

    doc.text(texto, 20, 30);

    /*
    let y = 20;
    const pageHeight = doc.internal.pageSize.height;

    contratos.forEach(contrato => {

      y = y + 10;

      doc.text(contrato.nmContrato, 20, y);
      
      if (y >= 280) {
        doc.addPage();
        y = 0; //Restart height position
      }
    });
    */

    return doc;
  }

  converterParaBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else
      byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  public deletarContrato(idContrato: any) {
    let urlObtencaoDados = "contrato/excluirContrato?idContrato=" + idContrato;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarAditivo(idAditivo: any) {
    let urlObtencaoDados = "contrato/excluirAditivo?idAditivo=" + idAditivo;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }


}



// WEBPACK FOOTER //
// ./src/providers/contrato-service.ts